import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    changeSubCategoryStatusAPI,
    updateSubCategoryAPIV2, fetchSubCategoryListAPIV2, createSubCategoryAPIV2, fetchSubCategoryByIdAPIV2, getAllSubCatagoriesAPIV2
} from '../apis/category.api.js';
import { successToastify } from '../utils/toastify.util.js';

const baseFields = {
    id: "",
    category_id: "",
    name: "",
    description: ""
}

const initialState = {
    isLoad: false,
    isBtnLoad: false,
    isRedirect: false,
    isUpdate: false,
    listData: [],
    totalCount: 0,
    status: 'idle',
    error: null,
    fields: baseFields,
    detailsData: null,
    allSubCatagories: []
};

// Async thunk for fetching categories
export const fetchSubCategories = createAsyncThunk(
    'subcategory/fetchSubCategories',
    async (payload, { rejectWithValue }) => {
        try {
            const response = await fetchSubCategoryListAPIV2(payload);
            return response?.result || { list: [], totalCount: 0 };
        } catch (err) {
            return rejectWithValue(err?.response?.data || { message: "Unable to load sub-categories." });
        }
    }
);

export const createSubCategory = createAsyncThunk(
    "subcategory/createSubCategory",
    async (payload, thunkAPI) => {
        try {
            const response = await createSubCategoryAPIV2(payload);
            if (response.success) {
                let req = {
                    limit: 10,
                    offset: 0,
                    searchText: ""
                }
                thunkAPI.dispatch(fetchSubCategories(req));
            }
            return response;
        } catch (err) {
            const { data } = err.response;
            return data;
        }
    }
)

export const fetchSubCategoryDataById = createAsyncThunk(
    "subcategory/fetchSubCategoryDataById",
    async (payload) => {
        try {
            const response = await fetchSubCategoryByIdAPIV2(payload);
            return response;
        } catch (err) {
            const { data } = err.response;
            return data;
        }
    }
)

export const updateSubCategory = createAsyncThunk(
    "subcategory/updateSubCategory",
    async (payload, thunkAPI) => {
        try {
            const response = await updateSubCategoryAPIV2(payload);
            if (response.success) {
                successToastify("subcategory updated successfully");
                let req = {
                    limit: 10,
                    offset: 0,
                    searchText: ""
                }
                thunkAPI.dispatch(fetchSubCategories(req));
            }
            return response;
        } catch (err) {
            const { data } = err.response;
            return data;
        }
    }
)

export const updateSubCategoryStatus = createAsyncThunk(
    "subcategory/updateSubCategoryStatus",
    async (payload, thunkAPI) => {
        try {
            const response = await changeSubCategoryStatusAPI(payload);
            if (response.success) {
                if (payload.status === 1) {
                    successToastify("Subcategory activated successfully");
                } else if (payload.status === 0) {
                    successToastify("Subcategory deactivated successfully");
                } else {
                    successToastify("Subcategory deleted successfully");
                }
                let req = {
                    limit: 10,
                    offset: 0,
                    searchText: ""
                }
                thunkAPI.dispatch(fetchSubCategories(req));
            }
            return response;
        } catch (err) {
            const { data } = err.response;
            return data;
        }
    }
)

export const fetchSubCategoryDataByCatagoryId = createAsyncThunk(
    "subcategory/fetchSubCategoryDataByCatagoryId",
    async (payload) => {
        try {
            const response = await getAllSubCatagoriesAPIV2(payload);
            return response;
        } catch (err) {
            const { data } = err.response;
            return data;
        }
    }
)

const subCategorySlice = createSlice({
    name: 'subcategory',
    initialState,
    reducers: {
        setRedirect: (state, action) => {
            state.isRedirect = action.payload;
        },
        setUpdate: (state, action) => {
            state.isUpdate = action.payload;
        },
        setPlanDetails: (state, action) => {
            state.detailsData = action.payload;
        },
        setFields: (state, action) => {
            state.fields = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSubCategories.pending, (state) => {
                state.status = 'loading';
                state.isLoad = true;
            })
            .addCase(fetchSubCategories.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.isLoad = false;
                state.isRedirect = false;
                const body = action.payload && typeof action.payload === "object" ? action.payload : {};
                state.listData = Array.isArray(body.list) ? body.list : [];
                state.totalCount = Number(body.totalCount) || 0;
            })
            .addCase(fetchSubCategories.rejected, (state, action) => {
                state.status = 'failed';
                state.isLoad = false;
                state.error = action.error.message;
            });


        builder.addCase(createSubCategory.pending, (state) => {
            state.isBtnLoad = true;
        });
        builder.addCase(createSubCategory.fulfilled, (state) => {
            state.isBtnLoad = false;
            state.isRedirect = true;
        });

        builder.addCase(fetchSubCategoryDataById.pending, (state) => {
            state.isLoad = true;
        });
        builder.addCase(fetchSubCategoryDataById.fulfilled, (state, action) => {
            state.isLoad = false;
            state.fields = action.payload.result;
        });

        builder.addCase(updateSubCategory.pending, (state) => {
            state.isBtnLoad = true;
        });
        builder.addCase(updateSubCategory.fulfilled, (state) => {
            state.isBtnLoad = false;
            state.isRedirect = true;
            state.fields = baseFields;
        });

        builder.addCase(fetchSubCategoryDataByCatagoryId.pending, (state) => {
            state.isLoad = true;
        });
        builder.addCase(fetchSubCategoryDataByCatagoryId.fulfilled, (state, action) => {
            state.isLoad = false;
            state.allSubCatagories = action.payload.result;
        });
    },
});

export const { setRedirect, setUpdate, setPlanDetails, setFields } = subCategorySlice.actions;

export default subCategorySlice.reducer;